/*
 * @Author: weixin_44214515 weixin_44214515@noreply.gitcode.com
 * @Date: 2024-06-12 09:14:40
 * @LastEditors: weixin_44214515 weixin_44214515@noreply.gitcode.com
 * @LastEditTime: 2024-06-12 09:43:13
 * @FilePath: /front-vps-admin/src/web-framework/components/YushuTableinfoDialog/tableinfo_dialog.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import tableinfoEditDialog from "./index.vue"; // 引入弹窗组件

const DatadicDialog = Vue.extend(tableinfoEditDialog);

tableinfoEditDialog.install = function (data) {
    let instance = new DatadicDialog({
        data,
    }).$mount();

    document.body.appendChild(instance.$el);

    Vue.nextTick(() => {
        instance.open();
    });
};

export default tableinfoEditDialog; // 导出